import { clsx } from "clsx";

import { alertBannerSectionPalettes } from "./class-names";
import { AlertProps } from "./types";
import { Button } from "../button";
import { Icon } from "../icon";
import { Link as LinkComponent } from "../link";

export const AlertSection = ({
  palette = "default",
  heading,
  content,
  actions,
  onClose,
}: AlertProps) => (
  <div
    className={clsx(
      alertBannerSectionPalettes[palette].background,
      "flex gap-small p-[1.6rem] rounded relative overflow-hidden min-h-fit",
    )}
  >
    <div
      className={clsx(
        alertBannerSectionPalettes[palette].borderColor,
        "w-full h-[0.4rem] absolute top-0 left-0 readable:w-[0.4rem] readable:h-full",
      )}
    />
    <div className={clsx(heading ? "pt-[0.4rem]" : "mt-[-0.2rem]")}>
      <span className="w-[2.4rem] h-[2.4rem] inline-flex justify-center items-center">
        <Icon
          className={alertBannerSectionPalettes[palette].iconColor}
          name={alertBannerSectionPalettes[palette].iconName}
        />
      </span>
    </div>
    <div className="flex flex-col justify-between">
      {heading && (
        <div className="flex gap-[0.8rem] items-center mb-[0.8rem]">
          <h2
            className={clsx(
              alertBannerSectionPalettes[palette].iconColor,
              "flex-1 text-paragraph font-semibold",
            )}
          >
            {heading}
          </h2>
        </div>
      )}
      <div>
        <div className="text-ui" data-testid="alert-section-content">
          {content}
        </div>
        {!!actions?.length && (
          <div className="flex gap-[1.6rem] mt-[1.6rem]">
            {actions.map((action, index) => (
              <LinkComponent
                key={action.text}
                variant={action.variant || "default"}
                text={action.text}
                onClick={action.onClick}
                dataTestId={`alert-section-action-${index}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
    {onClose && (
      <div className="flex">
        <Button
          variant="secondarySubtle"
          leftIcon="solidXmarkLarge"
          onClick={onClose}
          dataTestId="alert-section-close"
        />
      </div>
    )}
  </div>
);
